import { useCallback, useState } from 'react';

import ConfirmationDialog from '@sayyesschool/frontend/components/confirmation-dialog';
import FormDialog from '@sayyesschool/frontend/components/form-dialog';
import LoadingIndicator from '@sayyesschool/frontend/components/loading-indicator';
import PageSection from '@sayyesschool/frontend/components/page-section';
import { usePacks } from '@sayyesschool/frontend/features/packs';
import { useBoolean } from '@sayyesschool/frontend/hooks/state';

import PackForm from '@/components/packs/pack-form';
import PacksTable from '@/components/packs/packs-table';

export default function Packs() {
    const [packs, actions] = usePacks();

    const [pack, setPack] = useState();
    const [isCreateFormOpen, toggleCreateFormOpen] = useBoolean(false);
    const [isEditFormOpen, toggleEditFormOpen] = useBoolean(false);
    const [isDeleteDialogOpen, toggleDeleteDialogOpen] = useBoolean(false);

    const createPack = useCallback(data => {
        return actions.createPack(data)
            .then(() => toggleCreateFormOpen(false));
    }, [actions, toggleCreateFormOpen]);

    const updatePack = useCallback(data => {
        return actions.updatePack(pack.id, data)
            .then(() => {
                setPack(null);
                toggleEditFormOpen(false);
            });
    }, [pack, actions, toggleEditFormOpen]);

    const deletePack = useCallback(() => {
        return actions.deletePack(pack.id)
            .then(() => {
                setPack(null);
                toggleDeleteDialogOpen(false);
            });
    }, [pack, actions, toggleDeleteDialogOpen]);

    const handleCreate = useCallback(() => {
        toggleCreateFormOpen(true);
    }, [toggleCreateFormOpen]);

    const handleEdit = useCallback(pack => {
        setPack(pack);
        toggleEditFormOpen(true);
    }, [toggleEditFormOpen]);

    const handleDelete = useCallback(pack => {
        setPack(pack);
        toggleDeleteDialogOpen(true);
    }, [toggleDeleteDialogOpen]);

    if (!packs) return <LoadingIndicator />;

    return (
        <PageSection
            title="Пакеты"
            actions={[{
                key: 'add',
                icon: 'add',
                onClick: handleCreate
            }]}
            variant="outlined"
            compact
        >
            <PacksTable
                packs={packs}
                onEdit={handleEdit}
                onDelete={handleDelete}
            />

            <FormDialog
                title="Новый пакет"
                open={isCreateFormOpen}
                onClose={toggleCreateFormOpen}
            >
                <PackForm
                    id="create-pack-form"
                    onSubmit={createPack}
                />
            </FormDialog>

            <FormDialog
                title="Редактирование пакета"
                open={isEditFormOpen}
                onClose={toggleEditFormOpen}
            >
                <PackForm
                    id="edit-pack-form"
                    pack={pack}
                    onSubmit={updatePack}
                />
            </FormDialog>

            <ConfirmationDialog
                title="Подтвердите действие"
                message={'Вы действительно хотите удалить пакет?'}
                open={isDeleteDialogOpen}
                onConfirm={deletePack}
                onClose={toggleDeleteDialogOpen}
            />
        </PageSection>
    );
}